// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
import moment from 'moment'
// @end

// @import components
import {ContentInterestModuleLayout} from 'app_components/modules/newsEvents/contentInterest'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
import ContentInterestService from 'app_services/campus/contentInterest/contentInterestService'
import CourseService from 'app_services/campus/academic/courseService'
// @end

// @import types
import {IContentInterestModule} from 'app_types/campus/contentInterest/contentInterestTypes'
// @end

// @ADD Component types
interface IContentInterestModuleProps {
  module: IContentInterestModule
  locations?: Array<string>
}
interface IContentInterestModuleState {
  items: Array<any>
  loading: boolean
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class ContentInterestModule extends Component<IContentInterestModuleProps, IContentInterestModuleState> {

  private contentInterestService: ContentInterestService;
  private courseService: CourseService;

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IContentInterestModuleProps) {
    super(props)
    this.state = {
      items: [],
      loading: true
    }

    this.contentInterestService = new ContentInterestService()
    this.courseService = new CourseService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    if (this.props?.module) {
      await this.fetchDataByType()
    }
  }

  fetchDataByType = async () => {
    if (this.props?.module?.type === 'mooc') {
      await this.fetchDataMoocType()
    } else if (this.props?.module?.type === 'post') {
      await this.fetchDataPostType()
    }
  }

  private fetchDataPostType = async () => {
    let filters = {
      pageNumber: 1,
      nPerPage: 10,
      isActive: true,
      postType: [this.props.module.key],
      postDate: {
        date: 'today',
        direction: 'lte'
      },
      locations: this.props.locations || ['guest'],
      sort: {
        field: 'postDate',
        direction: -1
      }
    }

    const itemsResponse = await this.contentInterestService.fetchContentInterest(filters)

    let items: Array<any> = []

    if (itemsResponse && itemsResponse.posts) {
      items = itemsResponse.posts.reduce((accum: any, element: any) => {
        let item = {
          key: element?._id,
          cover: element?.coverUrl,
          title: element?.title,
          description: element?.subtitle,
          slug: element?.slug,
          link: this.getLink(),
          video: element?.video,
          researchUrl: element?.researchUrl,
          authors: element?.authors
        }

        accum.push(item)

        return accum
      }, [])
    }

    this.setState({
      items,
      loading: false
    })
  }

  private fetchDataMoocType = async () => {

    let filters = {
      pageNumber: 1,
      nPerPage: 10,
      startPublicationDate: {
        date: 'today',
        direction: 'lte'
      },
      endPublicationDate: {
        date: 'today',
        direction: 'gte'
      },
      price: ['mooc'],
      publish: true,
      sort: { typeCourse: 1 }
    }

    let courses: Array<any> = []
    const coursesResponse = await this.courseService.fetchCourses(filters)
    if (coursesResponse && coursesResponse.courses) {
      courses = coursesResponse.courses.reduce((accum: any, element: any) => {
        let startDate = moment.utc(element?.startDate).format('DD/MM/YY')
        let item = {
          key: element?._id,
          elementType: 'moocs',
          ...element,
          startDate,
          link: this.getLink()
        }

        accum.push(item)

        return accum
      }, [])
    }

    this.setState({
      items: courses,
      loading: false
    })
  }

  getLink = () => {
    let link: string | null = null
    if (this.props.module.key === 'moocs') {
      link = '/curso'
    } else if (this.props.module.key === 'webinar') {
      link = '/webinar'
    } else if (this.props.module.key === 'capsules') {
      link = '/capsula'
    } else if (this.props.module.key === 'research') {
      link = '/articulo'
    } else if (this.props.module.key === 'blog') {
      link = '/blog'
    } else if (this.props.module.key === 'podcast') {
      link = '/podcast'
    } else if (this.props.module.key === 'journal') {
      link = '/journals'
    }
    return link
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <ContentInterestModuleLayout
        module={this.props.module}
        items={this.state.items}
        loading={this.state.loading}
      />
    )
  }
}

export default connect(mapStatesToProps)(ContentInterestModule)
